import { Modal, ModalBackdrop, ModalContent } from "@/components/ui/modal";
import { WalletDTO } from "@/generated/api/models";
import { useMobileBreakpoint } from "@/utils/useMobileBreakpoint";
import { InterfaceModalProps } from "@gluestack-ui/modal/lib/types";
import { useState } from "react";
import { WalletPayoutModalAmount } from "./wallet.payout.modal.amount";
import { WalletPayoutModalConfirmation } from "./wallet.payout.modal.confirmation";

export function WalletPayoutModal({
  wallet,
  isOpen,
  onClose,
}: {
  wallet: WalletDTO;
} & Pick<InterfaceModalProps, "isOpen" | "onClose">) {
  const [payoutValue, setPayoutValue] = useState<number | undefined>();
  const [activePage, setActivePage] = useState<"AMOUNT" | "CONFIRMATION">(
    "AMOUNT"
  );

  const handleContinue = (amount: number) => {
    setPayoutValue(amount);
    setActivePage("CONFIRMATION");
  };

  const handleBack = () => {
    setActivePage("AMOUNT");
  };

  const handleClose = () => {
    onClose();
    setActivePage("AMOUNT");
  };

  const breakpoint = useMobileBreakpoint();

  return (
    <Modal isOpen={isOpen} onClose={handleClose} size="md">
      <ModalBackdrop />
      <ModalContent>
        {isOpen && activePage === "AMOUNT" && (
          <WalletPayoutModalAmount
            wallet={wallet}
            onClose={handleClose}
            onContinue={handleContinue}
          />
        )}
        {isOpen && activePage === "CONFIRMATION" && (
          <WalletPayoutModalConfirmation
            wallet={wallet}
            amount={payoutValue ?? 0}
            onClose={handleClose}
            onBack={handleBack}
          />
        )}
      </ModalContent>
    </Modal>
  );
}
